import { render, staticRenderFns } from "./CollectInformationAction.vue?vue&type=template&id=00440ca2&scoped=true&"
import script from "./CollectInformationAction.vue?vue&type=script&lang=js&"
export * from "./CollectInformationAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00440ca2",
  null
  
)

export default component.exports